"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import {
  HomeIcon,
  BuildingStorefrontIcon,
  RectangleStackIcon,
  CalendarDaysIcon,
  UserCircleIcon,
  ArrowRightOnRectangleIcon,
} from "@heroicons/react/24/outline";
import {
  HomeIcon as HomeIconSolid,
  BuildingStorefrontIcon as BuildingStorefrontIconSolid,
  RectangleStackIcon as RectangleStackIconSolid,
  CalendarDaysIcon as CalendarDaysIconSolid,
  UserCircleIcon as UserCircleIconSolid,
  ArrowRightOnRectangleIcon as ArrowRightOnRectangleIconSolid,
} from "@heroicons/react/24/solid";
import { useAuthUser } from "@/hooks/useAuthUser";

export default function BottomBar() {
  const pathname = usePathname();
  const { isAuthenticated } = useAuthUser();

  const getHomeUrl = () => (isAuthenticated ? "/conecta" : "/");

  const getNavItems = () => [
    {
      name: "Home",
      href: getHomeUrl(),
      icon: HomeIcon,
      iconSolid: HomeIconSolid,
    },
    {
      name: "Categorias",
      href: "/categorias",
      icon: RectangleStackIcon,
      iconSolid: RectangleStackIconSolid,
    },
    {
      name: "Empresas",
      href: "/empresas",
      icon: BuildingStorefrontIcon,
      iconSolid: BuildingStorefrontIconSolid,
    },
    {
      name: "Eventos",
      href: "/eventos",
      icon: CalendarDaysIcon,
      iconSolid: CalendarDaysIconSolid,
    },
  ];

  const profileNavItem = isAuthenticated
    ? {
        name: "Meu Perfil",
        href: "/perfil",
        icon: UserCircleIcon,
        iconSolid: UserCircleIconSolid,
      }
    : {
        name: "Fazer login",
        href: "/login",
        icon: ArrowRightOnRectangleIcon,
        iconSolid: ArrowRightOnRectangleIconSolid,
      };

  const isActive = (href: string) => {
    if (href === "/" || href === "/conecta") {
      return pathname === "/" || pathname === "/conecta";
    }
    return pathname.startsWith(href);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 md:hidden safe-area-inset-bottom">
      <div className="grid grid-cols-5 h-16 mb-4 mx-2">
        {[...getNavItems(), profileNavItem].map((item) => {
          const active = isActive(item.href);
          const Icon = active ? item.iconSolid : item.icon;

          return (
            <Link
              key={item.href}
              href={item.href}
              className={`flex flex-col items-center justify-center gap-1 transition-colors ${
                active ? "text-mygreen" : "text-gray-600 hover:text-mygreen"
              }`}
            >
              <Icon className="w-6 h-6" />
              <span className="text-xs font-medium">{item.name}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
